import React from 'react';
import { EditorState } from 'draft-js';
import CommentAssets from '../../../CommentAssets';
import { RichTextEditor } from '../../../../../RichTextEditor';





















const CommentTextEditor = ({
  onUpdateContent,
  placeholder,
  editorState,
  inputType,
  onSave,
  disabled,
  onCancel,
  assetIds = [],
  commentId,
  onFilesChange,
  canAddAsset,
  canDeleteAsset,
  organisationId,
  onFocus,
  setFocusOnMount = true
}) =>
<RichTextEditor
  onUpdateContent={onUpdateContent}
  placeholder={placeholder}
  editorState={editorState}
  inputType={inputType}
  onSave={onSave}
  disabled={disabled}
  onCancel={onCancel}
  organisationId={organisationId}
  hideControls
  onFocus={onFocus}
  setFocusOnMount={setFocusOnMount}>

    <CommentAssets
    assetIds={assetIds}
    commentId={commentId}
    canAdd={canAddAsset && !disabled}
    onFilesChange={onFilesChange}
    canDelete={canDeleteAsset} />

  </RichTextEditor>;


export default CommentTextEditor;